<script setup>
import { ref } from 'vue'
const links = ref([
    {
        title: 'Contact',
        url: 'https://www.logitech.com/en-us/about/contact.html'
    },
    {
        title: 'Web Privacy Policy',
        url: 'https://www.logitech.com/en-us/legal/web-privacy-policy.html'
    },
    {
        title: 'Product Privacy Policy',
        url: 'https://www.logitech.com/en-us/legal/product-privacy-policy.html'
    },
    {
        title: 'Terms & Conditions',
        url: 'https://drive.google.com/file/d/14A_JHhWkcVJCPO4SqaD_9bPA98Z7JF34/view'
    }
])
const socials = ref([
    {
        platform: 'facebook',
        url: 'https://www.facebook.com/LogitechG/'
    },
    {
        platform: 'twitter',
        url: 'https://twitter.com/logitechg'
    },
    {
        platform: 'instagram',
        url: 'https://www.instagram.com/logitechg/'
    },
    {
        platform: 'twitch',
        url: 'https://www.twitch.tv/logitechg'
    },
    {
        platform: 'youtube',
        url: 'https://www.youtube.com/c/LogitechG'
    }
])
</script>

<template>
    <footer class="lg:fixed bottom-0 left-0 w-full lg:h-48 bg-carbon-200 text-white flex items-center text-sm uppercase lg:py-0 py-12">
        <div class="container">
            <div class="flex lg:flex-row flex-col lg:gap-0 gap-12 justify-between">
                <div class="flex flex-col gap-2">
                    <p class="font-bold">Powered by</p>
                    <a href="https://www.logitechg.com/en-gb" target="blank">
                        <img class="h-12" src="https://d1f3y6u6f3nh06.cloudfront.net/images/logos/logitechg.svg" alt="">
                    </a>
                </div>
                <div class="flex flex-col gap-8">
                    <div class="flex flex-col gap-3">
                        <h5 class="font-bold">Resources</h5>
                        <nav class="flex items-center lg:gap-6 gap-4">
                            <a class="text-white/50 hover:text-white transition-colors" :href="link.url" target="_blank" v-for="link, i in links" :key="i">{{ link.title }}</a>
                        </nav>
                    </div>
                    <div class="flex items-center gap-4">
                        <a class="text-xl hover:text-white/50 transition-colors" v-for="social, i in socials" :key="i" :href="social.url" target="_blank">
                            <i :class="'fa-brands fa-'+social.platform"></i>
                        </a>
                        <button id="onetrust-pc-btn-handler" class="ot-sdk-show-settings text-xs uppercase cookie-setting-link">Cookie Settings</button>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
